//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Form from 'vform'
import veeValidate from '~/mixins/veeValidate'
import VueToastMixin from '~/mixins/plugins/vue-toastification'

export default {
  name: 'OffersInMailbox',
  mixins: [veeValidate, VueToastMixin],
  props: {
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    enabled: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      busy: {
        form: false
      },
      form: new Form({
        email: ''
      }),
      formRules: {
        email: 'required|email'
      }
    }
  },
  methods: {
    async submit () {
      const isValid = await this.$refs.formObs.validate()
      this.busy.form = true

      if (!isValid) {
        this.formIsBusy = false
        return false
      }
      const lang = this.$nuxt.$store.getters['lang/locale']
      await this.$axios.post('/api/users/subscribe', {
        lang,
        ...this.form
      }).then(async (response) => {
        this.$toast.info(this.$t('you-are-subscribed'))
      }).catch(async (response) => {
        this.$toast.error(this.$t('an-error-has-occurred'))
      })

      this.busy.form = false
    }
  }
}
